<template>
    <div>
        <span v-if="isPending"> Pending </span>
        <span v-else-if="isVerified">
            Verified - {{ verificationDate }}
            <br />
            <small v-if="alertLogs">{{ alertLogs }}</small>
        </span>
        <span v-else-if="isFailed">
            <span>
                Failed Verification - {{ verificationDate }}
                <b-button variant="default" class="ml-1" size="xs" @click="$bvModal.show(modalId)"
                    >ID OK?</b-button
                ></span
            >

            <br />
            <small v-if="failedVerificationLog">{{ failedVerificationLog }}</small>
        </span>
        <span v-else-if="isNotSeen"> Not seen </span>
        <span v-else> In Progress </span>
        <guest-verification-staff-approved-modal :modalId="modalId" :verify="verify" />
    </div>
</template>

<script>
    import format from 'date-fns/format';
    import parseISO from 'date-fns/parseISO';
    import { mapGetters } from 'vuex';
    import guestVerificationStaffApprovedModal from './guest-verification-staff-approved-modal.vue';
    export default {
        components: { guestVerificationStaffApprovedModal },
        computed: {
            ...mapGetters('header', ['userUnicodeDateFormat']),
            alertLogs() {
                const alertLog = this.params?.data.logs.find((item) => item.message.indexOf('Alert!') !== -1)?.message;
                return alertLog;
            },
            failedVerificationLog() {
                const logs = this.params.data.logs
                    .filter((item) => item.message.toLowerCase().indexOf('failed verification') !== -1)
                    .map((item) => `${item.message}`)
                    .join('');
                return logs;
            },
            isPending() {
                const data = this.params?.data;
                return data && data.seen && !data.verified_on && !data.transaction_id;
            },
            isVerified() {
                return this.params?.data?.is_verified;
            },
            isFailed() {
                return this.params?.data?.verified_on && !this.params?.data?.is_verified;
            },
            isNotSeen() {
                return this.params?.data && !this.params?.data?.seen;
            },
            verificationDate() {
                return format(parseISO(this.params.data.verified_on), this.userUnicodeDateFormat);
            },
            modalId() {
                return 'modal-verify-id' + this.params?.data?.id;
            },
        },
        methods: {
            async verify() {
                this.params.verify && this.params.verify(this.params.data.id, this.modalId);
            },
        },
    };
</script>

<style></style>
